import { ShieldCheck, Scale, BadgeCheck, Lock, Star, Building2 } from "lucide-react";

const ITEMS = [
    { icon: ShieldCheck, label: "FCA Aware", sub: "Compliance-led ops" },
    { icon: Scale, label: "SRA Solicitors", sub: "Specialist legal team" },
    { icon: BadgeCheck, label: "No Win, No Fee", sub: "Zero upfront cost" },
    { icon: Lock, label: "GDPR & ICO", sub: "Bank-level security" },
    { icon: Star, label: "5★ Trustpilot", sub: "Rated Excellent" },
    { icon: Building2, label: "£218m+ Recovered", sub: "For our clients" },
];

export default function TrustBar({ tone = "light" }) {
    const dark = tone === "dark";
    return (
        <div className={`${dark ? "bg-navy-900 border-white/10" : "bg-white border-slate-200"} border-y`}>
            <div className="container-x py-6">
                <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-5 lg:gap-8">
                    {ITEMS.map(({ icon: Icon, label, sub }) => (
                        <div key={label} className="flex items-center gap-3">
                            <div className={`w-10 h-10 rounded-xl flex items-center justify-center ${dark ? "bg-white/5 border border-white/10" : "bg-emerald-50 border border-emerald-100"}`}>
                                <Icon className={`w-5 h-5 ${dark ? "text-emerald-400" : "text-emerald-600"}`} />
                            </div>
                            <div>
                                <div className={`text-sm font-semibold leading-tight ${dark ? "text-white" : "text-navy-900"}`}>{label}</div>
                                <div className={`text-xs leading-tight ${dark ? "text-slate-400" : "text-slate-500"}`}>{sub}</div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}
